import {RatingStars} from '@frontend/components/RatingStars'
import {trans} from '@frontend/helpers'
import type {ReviewsListItemData} from '@frontend/modules/public/shared/reviews/ReviewsModuleTypes'
import {type ReactNode} from 'react'
import {UserAvatar} from '../../../../components/UserAvatar'

interface Props {
    review: ReviewsListItemData
    reviewedItemTitle?: ReactNode
}

// Отображение отзыва в списке.
export function ReviewsListItem(props: Props) {

    const {
        review,
        reviewedItemTitle,
    } = props

    return (
        <div className="mt-4 d-flex flex-row align-items-start justify-content-start">
            <div className="flex-shrink-0 me-3">
                <UserAvatar
                    userName={review.reviewer.name}
                    small
                    className="mt-1"
                />
            </div>
            <div className="flex-1">
                <div className="flex-row-between">
                    <div className="fw-500">
                        {review.reviewer.name}
                    </div>
                    <div className="text-muted d-none d-sm-block">
                        {review.createdAt}
                    </div>
                </div>
                <div>
                    <RatingStars
                        rating={review.rating}
                        starSize={20}
                        inactiveIconColor="light-gray"
                    />
                </div>
                <div className="d-sm-none mt-1 text-muted">
                    {review.createdAt}
                </div>
                {reviewedItemTitle && (
                    <div className="mt-2">
                        {reviewedItemTitle}
                    </div>
                )}
                {review.review && review.review.length > 0 && (
                    <>
                        <div className="mt-2 text-muted">
                            {trans().reviews.comment}:
                        </div>
                        <div className="text-multiline">
                            {review.review}
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}
